module.exports = __webpack_public_path__ + "img/me.60514a80.jpg";